import { compose } from 'redux';
import { connect } from 'react-redux';
import { reduxForm } from 'redux-form';
import AddInstructorModal from './AddInstructorModal';
import { createInstructor } from '../../../Schedules.saga';
import messages from '../../ScheduleForm.messages';

const validate = values => {
  const errors = {};
  if (!values.firstName) {
    errors.firstName = messages.validator.requiredField;
  }

  return errors;
};

const mapDispatchToProps = {
  onSubmit: createInstructor,
};

export default compose(
  connect(null, mapDispatchToProps),
  reduxForm({
    form: 'ADD_CLASS_FORM',
    validate,
  })
)(AddInstructorModal);
